import API_BASE_URL from "../../../../../Constants";

export const updateCustomer = async (customerId, data) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/setup/customers/${customerId}`,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(data),
      }
    );
    return response.status === 200;
  } catch (error) {
    console.error("Failed to save customer:", error);
    throw error;
  }
};
